
import { defineComponent, ref, onMounted, watch } from "vue";
import { usePlugin } from "@/plugins";
import { Question, GetQuestionResponse } from "@/types";
export default defineComponent({
  name: "InputQuestion",
  props: {
    modelValue: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { axios, error, information } = usePlugin();
    const questions = ref([] as Question[]);
    const selectedQuestion = ref("");
    const isLoading = ref(false);

    const loadQuestion = async () => {
      isLoading.value = true;
      try {
        const result = await axios.post<GetQuestionResponse>(
          "api/v1/services/question/get",
          {
            searchString: "",
          }
        );
        questions.value = result.data.questions ?? [];
        if ((result.data.questions?.length ?? 0) === 0)
          information("ไม่พบข้อมูล");
      } catch (e) {
        error("ไม่สามารถติดต่อ server กรุณาลองใหม่ภายหลัง");
      } finally {
        isLoading.value = false;
      }
    };

    watch(
      () => props.modelValue,
      () => {
        console.log("set question value " + props.modelValue);
        selectedQuestion.value = props.modelValue ?? "";
      }
    );

    onMounted(async () => {
      await loadQuestion();
      if (props.modelValue) {
        selectedQuestion.value = props.modelValue;
      }
    });

    const onSelectQuestion = (value: any) => {
      emit("update:modelValue", value.value);
    };

    return {
      selectedQuestion,
      questions,
      onSelectQuestion,
      isLoading,
    };
  },
});
